(function () {

    'use strict';

    angular.module('iplusjs.exceptionHandler', [
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.utils.format',
        'lodash',
        'stacktrace',
        'md5'
    ])
        .config(config)
        .run(run)
        .service('ExceptionHandlerService', ExceptionHandlerService);

    config.$inject = [
        '$provide'
    ];

    function config($provide) {
        $provide.decorator('$exceptionHandler', exceptionHandlerDecorator);

        exceptionHandlerDecorator.$inject = [
            '$delegate',
            '$injector'
        ];

        function exceptionHandlerDecorator($delegate, $injector) {
            var _exceptionHandler = $delegate;

            return function (exception, cause) {
                var ExceptionHandlerService = $injector.get('ExceptionHandlerService');
                _exceptionHandler.apply(null, arguments);
                ExceptionHandlerService.logRemote(exception);

                return $delegate;
            };
        }
    }

    run.$inject = [
        '$injector',
        '$window'
    ];

    function run($injector, $window) {
        var ExceptionHandlerService = $injector.get('ExceptionHandlerService');

        ExceptionHandlerService.init();

        if (ExceptionHandlerService) {
            $window.onerror = function (msg, file, line, col, error) {
                if (msg !== 'Script error.') {
                    ExceptionHandlerService.logRemote(error);
                }
            };
        }

    }

    ExceptionHandlerService.$inject = [
        '$rootScope',
        '$injector',
        '$log',
        '$q',
        '$window',
        'lodash',
        'stacktrace',
        'md5',
        'AppConfig',
        'MiscUtilsService',
        'FormatUtilsService'
    ];

    function ExceptionHandlerService($rootScope, $injector, $log, $q, $window, _, stacktrace, md5, AppConfig, MiscUtilsService, FormatUtilsService) {
        var that = this,
            $http = $injector.get('$http'),
            remoteLoggingConf = AppConfig.APP.logging.remoteLogging || {},
            CustomExceptionHandler = $injector.has(remoteLoggingConf.customExceptionHandlerName) && $injector.get(remoteLoggingConf.customExceptionHandlerName),
            exceptionHandlerData = {},
            stacktraceCache = {},
            pendingRequests = {};

        that.init = init;
        that.logRemote = logRemote;
        that.handleStacktraceInCache = handleStacktraceInCache;

        function log(stackframes, message, forceLogging, suppressAlert) {
            if (MiscUtilsService.isEmpty(CustomExceptionHandler)) {
                return $q.reject('NO_CUSTOM_EXCEPTION_HANDLER_DEFINED');
            }

            var st,
                stringifiedStack = stackframes.map(function (sf) {
                    return sf.toString();
                }).join('\n'),
                httpConfig = {
                    method: remoteLoggingConf.httpMethod,
                    headers: {
                        'Content-Type': remoteLoggingConf.httpHeaderContentType || 'application/json'
                    },
                    url: remoteLoggingConf.url,
                    globalErrorsIgnore: {
                        errors: true,
                        nachrichten: true
                    },
                    httpErrorsIgnore: true
                },
                httpDataParams = {};

            if (!stringifiedStack) {
                return $q.reject('NO_STACKTRACE');
            }
            if (!forceLogging && !remoteLoggingConf.stacktraceRegex && !remoteLoggingConf.stacktraceRegex.test(stringifiedStack)) {
                return $q.reject('NO_STACKTRACE_VALID_REGEX');
            }
            st = handleStacktraceInCache(stringifiedStack);
            if (st.exists) {
                if (!pendingRequests[_.get(st, 'stacktraceCache.md5Hash')]) {
                    if (suppressAlert !== true) {
                        $rootScope.$emit('iplusjs:createAndAddAlert', {
                            message: _.get(st, 'stacktraceCache.errorId') ? FormatUtilsService.replace(AppConfig.MESSAGES.unexpectedWithErrorId, _.get(st, 'stacktraceCache.errorId')) : AppConfig.MESSAGES.unexpected,
                            type: 'alert',
                            compareField: _.get(st, 'stacktraceCache.md5Hash')
                        });
                    }
                }

                return $q.resolve();
            }

            httpDataParams[remoteLoggingConf.httpMethod === 'GET' ? 'params' : 'data'] = CustomExceptionHandler.getData(exceptionHandlerData, stringifiedStack, message);
            httpConfig = angular.merge(httpConfig, httpDataParams);

            pendingRequests[_.get(st, 'stacktraceCache.md5Hash')] = true;

            return $http(httpConfig).then(function (response) {
                _.set(st, 'stacktraceCache.errorId', CustomExceptionHandler.getErrorId(response.data));
            }).finally(function () {
                if (suppressAlert !== true) {
                    $rootScope.$emit('iplusjs:createAndAddAlert', {
                        message: _.get(st, 'stacktraceCache.errorId') ? FormatUtilsService.replace(AppConfig.MESSAGES.unexpectedWithErrorId, _.get(st, 'stacktraceCache.errorId')) : AppConfig.MESSAGES.unexpected,
                        type: 'alert',
                        compareField: _.get(st, 'stacktraceCache.md5Hash')
                    });
                }

                delete pendingRequests[_.get(st, 'stacktraceCache.md5Hash')];
            });
        }

        function init() {
            exceptionHandlerData = {};
            stacktraceCache = {};
            pendingRequests = {};

            exceptionHandlerData.id = MiscUtilsService.guid();

            if (angular.isFunction(CustomExceptionHandler)) {
                exceptionHandlerData = CustomExceptionHandler.init(exceptionHandlerData);
            }
        }
        function logRemote(error, forceLogging, suppressAlert) {
            error = error || {};

            if (error.stack && error.stack.indexOf($window.location.origin) === -1) {
                $log.info('No app exception. Maybe the exception is from a browser extension.', error);
                return;
            }

            if (remoteLoggingConf.enabled && remoteLoggingConf.url) {
                stacktrace.fromError(error).then(function (stackframes) {
                    return log(stackframes, error.message, forceLogging, suppressAlert);
                }).catch(function (e) {
                    $log.warn('Error logging failed', e);
                });
            }
        }

        function handleStacktraceInCache(stringifiedStacktrace) {
            try {
                var md5Hash = md5(stringifiedStacktrace);

                if (!stacktraceCache[md5Hash]) {
                    stacktraceCache[md5Hash] = {
                        md5Hash: md5Hash
                    };
                    return {
                        exists: false,
                        stacktraceCache: stacktraceCache[md5Hash]
                    };
                } else {
                    return {
                        exists: true,
                        stacktraceCache: stacktraceCache[md5Hash]
                    };
                }
            } catch (error) {
                $log.warn(error);
            }

            return {
                exists: false,
                stacktraceCache: {}
            };
        }
    }
})();
